const MONITORING_DATE_LOCALE_OPTIONS: Intl.DateTimeFormatOptions = {
  year: "numeric",
  month: "short",
  day: "numeric",
};

/** Format an ISO datetime string as a localized "MMM D, YYYY" date, or "" when absent/invalid. */
export function formatMonitoringDate(date: string | null | undefined): string {
  if (!date) {
    return "";
  }
  const parsed = new Date(date);
  if (Number.isNaN(parsed.getTime())) {
    return "";
  }
  return parsed.toLocaleDateString(undefined, MONITORING_DATE_LOCALE_OPTIONS);
}

/** Format an ISO date string (YYYY-MM-DD) as a localized date, or "" when absent/invalid. */
export function formatMonitoringIsoDate(
  date: string | null | undefined
): string {
  if (!date) {
    return "";
  }
  const parts = date.split("-");
  if (parts.length !== 3) {
    return "";
  }
  const [yearStr, monthStr, dayStr] = parts;
  const year = Number(yearStr);
  const month = Number(monthStr);
  const day = Number(dayStr);
  if (
    Number.isNaN(year) ||
    Number.isNaN(month) ||
    Number.isNaN(day) ||
    month < 1 ||
    month > 12 ||
    day < 1 ||
    day > 31
  ) {
    return "";
  }
  const parsed = new Date(year, month - 1, day);
  if (
    parsed.getFullYear() !== year ||
    parsed.getMonth() !== month - 1 ||
    parsed.getDate() !== day
  ) {
    return "";
  }
  return parsed.toLocaleDateString(undefined, MONITORING_DATE_LOCALE_OPTIONS);
}

/** Format a comma-separated ISO date range as a localized label, or the fallback when invalid. */
export function formatMonitoringDateRangeLabel(
  dateRange: string,
  fallback: string
): string {
  const [start, end] = dateRange.split(",");
  if (!start || !end) {
    return fallback;
  }
  const formattedStart = formatMonitoringIsoDate(start);
  const formattedEnd = formatMonitoringIsoDate(end);
  if (!formattedStart || !formattedEnd) {
    return fallback;
  }
  return `${formattedStart} - ${formattedEnd}`;
}
